import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import { useQuery } from 'react-query';
import API from 'core/Api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { IDropdowns } from '../types';
import CreateForm from './CreateForm';

export interface IProps {
  fieldsEntityName: string;
  fieldsDropdownsEntityName: string;
  fieldsDropdownsEntityEndpoint: string;
}

const Create: FC<IProps> = ({ fieldsEntityName, fieldsDropdownsEntityName, fieldsDropdownsEntityEndpoint }) => {
  const { client } = useActiveClientContext();
  const {
    isLoading,
    error,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>([buildClientEntity(fieldsDropdownsEntityName, client)], (): Promise<IDropdowns> => {
    return API.get(fieldsDropdownsEntityEndpoint).then(res => res.data && res.data);
  });

  return (
    <MainLayout
      title="Добавяне на поле"
      isLoading={isLoading}
      error={error}
    >
      {dropdowns && (
        <CreateForm
          fieldsEntityName={fieldsEntityName}
          fieldDataOptions={dropdowns}
        />
      )}
    </MainLayout>
  );
};

export default Create;
